export default "__VITE_ASSET__1d7c5fd0__"